// Comprime imágenes (JPG/PNG/WebP) en el navegador antes de subir.
// - Reescala a max 1920px en el lado mayor (no afecta visualización en pantalla).
// - Convierte a JPEG calidad 0.82 por defecto (sin pérdida visual perceptible).
// - Si no es imagen, retorna el archivo original sin tocarlo (PDFs se comprimen en backend).
export const compressImage = (file, maxWidth = 1920, quality = 0.82) => {
    return new Promise((resolve, reject) => {
        if (!file || !file.type || !file.type.startsWith('image/')) {
            resolve(file);
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;

                if (width > maxWidth) {
                    height = (height * maxWidth) / width;
                    width = maxWidth;
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            const newName = file.name.replace(/\.(png|webp|jpeg|jpg)$/i, '.jpg');
                            const compressedFile = new File([blob], newName, {
                                type: 'image/jpeg',
                                lastModified: Date.now(),
                            });
                            // Si la compresión empeoró (raro), usar el original
                            if (compressedFile.size >= file.size) {
                                resolve(file);
                                return;
                            }
                            // eslint-disable-next-line no-console
                            console.log(
                                `[compressImage] ${file.name}: ${(file.size / 1024).toFixed(1)}KB -> ${(compressedFile.size / 1024).toFixed(1)}KB`
                            );
                            resolve(compressedFile);
                        } else {
                            resolve(file);
                        }
                    },
                    'image/jpeg',
                    quality
                );
            };
            img.onerror = () => reject(new Error('Error cargando imagen'));
            img.src = e.target.result;
        };
        reader.onerror = () => reject(new Error('Error leyendo archivo'));
        reader.readAsDataURL(file);
    });
};

export default compressImage;
